import React from 'react'
import { useTranslation } from 'react-i18next';

import mother from '../../Assets/images/static/01.svg';
import pension from '../../Assets/images/static/02.svg';
import one from '../../Assets/images/static/03.svg';
import ins from '../../Assets/images/static/04.svg';

const Howhelp = () => {
  const { t } = useTranslation();
  
  return (
    <div>
        <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div className="contain-infor">
                    <h2>{t('howhelp.title')}</h2>
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div className="contain-help">
                        <img src={mother} alt={t('howhelp.singleMothers')} />
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div className="contain-help">
                        <img src={pension} alt={t('howhelp.pensioners')} />
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div className="contain-help">
                        <img src={one} alt={t('howhelp.elderlyLonely')} />
                    </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div className="contain-help">
                        <img src={ins} alt={t('howhelp.disabled')} />
                    </div>
                </div>
            </div>
    </div>
  )
}

export default Howhelp